export enum FacilityEntityType {
  OFFICE = "office",
  FLOOR = "floor",
  ZONE = "zone",
  RESOURCE = "resource",
}

export enum FacilityPolicyScope {
  BOOKING = "BOOKING",
  SCHEDULING = "SCHEDULING",
  VISITORS = "VISITORS",
}

export enum FacilityPolicyEffectType {
  DENY = "DENY",
}
